export default "__VITE_ASSET__9Yjn6vkw__"